import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import s from './WebFooter.module.scss';
import getAssetLink from '../../util/getAssetLink';
import { ROUTE_PREFIX } from '../../constants/router';
import { openConsentSettings } from '../../util/trackingConsent';

export const PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=at.arbeiterkammer.jopsy';
export const APP_STORE_LINK =
  'https://apps.apple.com/at/app/ak-jopsy/id1463955933';

export const footerLinks = [
  {
    title: 'DATENSCHUTZ',
    href: `${ROUTE_PREFIX}/datenschutz`,
    ariaLabel: 'Zur Datenschutzerklärung',
  },
  {
    title: 'IMPRESSUM',
    href: `${ROUTE_PREFIX}/impressum`,
    ariaLabel: 'Zum Impressum',
  },
];

function WebFooter(): ReactElement {
  return (
    <div className={s.footer}>
      <div className={s.footerContent}>
        <nav>
          <span className={s.storeLabel}>Lade die App herunter</span>
          <a
            className={s.storeLink}
            href={PLAY_STORE_LINK}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={getAssetLink('playStore.png')}
              alt="Play Store"
              aria-label="Zum Play Store"
            />
          </a>
          <a
            className={s.storeLink}
            href={APP_STORE_LINK}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={getAssetLink('appStore.png')}
              alt="App Store"
              aria-label="Zum App Store"
            />
          </a>
        </nav>
        <nav>
          {footerLinks.map((link) => (
            <Link
              key={link.href}
              className={s.link}
              to={link.href}
              aria-label={link.ariaLabel}
            >
              <span>{link.title}</span>
            </Link>
          ))}
          <button
            type="button"
            className={`btn-no-style ${s.link}`}
            onClick={openConsentSettings}
            aria-label="Cookie Einstellungen öffnen"
          >
            <span>COOKIE PRÄFERENZEN</span>
          </button>
        </nav>
      </div>
    </div>
  );
}

export default WebFooter;
